module.exports = {
      id: "german-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#german-usage",
      toString: function () {
        return this.url;
      }
    }